export default "__VITE_ASSET__C1tXftW9__"